document.addEventListener('DOMContentLoaded', function() {
  var tabs = document.querySelectorAll('ul.shopify-tabs > li');
  
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var tab_id = this.getAttribute('data-tab');
      
      tabs.forEach(function(tab) {
        tab.classList.remove('current');
      });
      
      var tabContents = document.querySelectorAll('.shopify-tab-content');
      tabContents.forEach(function(content) {
        content.classList.remove('current');
      });
      
      this.classList.add('current');
      document.getElementById(tab_id).classList.add('current');
    });
  });

  // if(document.querySelectorAll('.read_more_set').length){
  //   document.querySelector('.read_more_set').addEventListener("click", function() {
  //     this.closest('.shopify-tab-content').querySelector('.product_short_description').style.display = "none";
  //     this.closest('.shopify-tab-content').querySelector('.product_full_description').style.display = "block";
  //   });
  //   document.querySelector('.read_less_set').addEventListener("click", function() {
  //     this.closest('.shopify-tab-content').querySelector('.product_short_description').style.display = "block";
  //     this.closest('.shopify-tab-content').querySelector('.product_full_description').style.display = "none";
  //   });
  // }

  // if(document.querySelectorAll('.read_more_set').length){
  //   document.querySelector('.product_short_description').style.display = "block";
  //   var custom_data = document.querySelector(".product_full_description").innerHTML;
  //   var truncatedContent = custom_data.substring(0, 600);
  //   document.querySelector('.product_short_description').innerHTML = truncatedContent;
    
  //   document.querySelector('.read_more_set').addEventListener("click", function() {
  //     this.closest('.shopify-tab-content').querySelector('.read_less_set').style.display = "block";
  //     this.closest('.shopify-tab-content').querySelector('.read_more_set').style.display = "none";
  //      this.closest('.shopify-tab-content').querySelector('.product_short_description').innerHTML = custom_data;
  //   });
    
  //   document.querySelector('.read_less_set').addEventListener("click", function() {
  //     this.closest('.shopify-tab-content').querySelector('.read_less_set').style.display = "none";
  //     this.closest('.shopify-tab-content').querySelector('.read_more_set').style.display = "block";
  //      this.closest('.shopify-tab-content').querySelector('.product_short_description').innerHTML = truncatedContent;
  //   });
  // }
  
  if(document.querySelectorAll(".accordion__wrapper_new button").length > 0){
    const elements = document.querySelectorAll(".accordion__wrapper_new button");
    elements.forEach(function(item){
      item.addEventListener("click", function() {
        if(item.classList.contains('accordion-is-open')){
          item.classList.remove('accordion-is-open');
          item.closest('.accordion__wrapper_new').querySelector('.accordion__body').style.height = "0px";
          item.closest('.accordion__wrapper_new').classList.remove('current');
        }else{
          elements.forEach(function(newitem){
            newitem.closest('.accordion__wrapper_new').querySelector('.accordion__body').style.height = "0px";
            newitem.classList.remove('accordion-is-open');
            newitem.closest('.accordion__wrapper_new').classList.remove('current');
          })
          var height = item.closest('.accordion__wrapper_new').querySelector('.accordion__body').scrollHeight;
          item.closest('.accordion__wrapper_new').querySelector('.accordion__body').style.height = height + 'px';
          item.classList.add('accordion-is-open');
          item.closest('.accordion__wrapper_new').classList.add('current');
        }
      });
    })
  }
});
